function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#102E8E",
  fillRule: "evenodd",
  d: "M10.2 15.938V8.061L15.6 12l-5.4 3.938zm9-10.588C18.66 5.175 15.33 5 12 5s-6.66.166-7.2.332C3.396 5.787 3 8.85 3 12c0 3.141.396 6.212 1.8 6.659.54.175 3.87.341 7.2.341s6.66-.166 7.2-.341C20.604 18.212 21 15.14 21 12c0-3.15-.396-6.204-1.8-6.65z"
});

var SvgIcYoutube = function SvgIcYoutube(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjIgMTUuOTM4VjguMDYxTDE1LjYgMTJsLTUuNCAzLjkzOHptOS0xMC41ODhDMTguNjYgNS4xNzUgMTUuMzMgNSAxMiA1cy02LjY2LjE2Ni03LjIuMzMyQzMuMzk2IDUuNzg3IDMgOC44NSAzIDEyYzAgMy4xNDEuMzk2IDYuMjEyIDEuOCA2LjY1OS41NC4xNzUgMy44Ny4zNDEgNy4yLjM0MXM2LjY2LS4xNjYgNy4yLS4zNDFDMjAuNjA0IDE4LjIxMiAyMSAxNS4xNCAyMSAxMmMwLTMuMTUtLjM5Ni02LjIwNC0xLjgtNi42NXoiLz4KPC9zdmc+Cg==";
export { SvgIcYoutube as ReactComponent };